import {
  GetAllTaxRelatedToCountry,
  LookupList,
  SaveAllTax,
  UpdateTax,
} from '../../../../../../types/ProjectManagement/Project/ProjectView/Invoices/addTaxListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../utils/apiUtils'
import { AddTaxApiConfig, AllowedHttpMethods } from '../../../../apiList'

const getAllTaxRelatedToCuntryList = async (
  props: string,
): Promise<GetAllTaxRelatedToCountry[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddTaxApiConfig.country + `/${props}`,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const saveAllTaxs = async (addNewTax: SaveAllTax): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddTaxApiConfig.saveAllTax,
    method: AllowedHttpMethods.post,
    data: addNewTax,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const updateTaxs = async (updateTaxList: UpdateTax): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddTaxApiConfig.updateTax,
    method: AllowedHttpMethods.put,
    data: updateTaxList,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const lookup = async (): Promise<LookupList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddTaxApiConfig.lookup,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteTaxList = async (props: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddTaxApiConfig.deleteTax + `/${props}`,
    method: AllowedHttpMethods.delete,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const addTaxApi = {
  getAllTaxRelatedToCuntryList,
  saveAllTaxs,
  updateTaxs,
  deleteTaxList,
  lookup,
}
export default addTaxApi
